import type { NodePolicy } from '@deepcloud/api-deep-box'

export function useNodePolicy() {
  const canAddChildren = (node: { policy: NodePolicy }) =>
    node?.policy?.canAddChildren || false

  const canAdminAccess = (node: { policy: NodePolicy }) =>
    node?.policy?.canAdminAccess || false

  const canAnalyze = (node: { policy: NodePolicy }) =>
    node?.policy?.canAnalyze || false

  const canComment = (node: { policy: NodePolicy }) =>
    node?.policy?.canComment || false

  const canDelete = (node: { policy: NodePolicy }) =>
    node?.policy?.canDelete || false

  const canDirectDownload = (node: { policy: NodePolicy }) =>
    node?.policy?.canDirectDownload || false

  const canDownload = (node: { policy: NodePolicy }) =>
    node?.policy?.canDownload || false

  const canListChildren = (node: { policy: NodePolicy }) =>
    node?.policy?.canListChildren || false

  const canI18n = (node: { policy: NodePolicy }) =>
    node?.policy?.canI18n || false

  const canMoveOutOfBox = (node: { policy: NodePolicy }) =>
    node?.policy?.canMoveOutOfBox || false

  const canMoveWithinBox = (node: { policy: NodePolicy }) =>
    node?.policy?.canMoveWithinBox || false

  const canPurge = (node: { policy: NodePolicy }) =>
    node?.policy?.canPurge || false

  const canReadNodeInfo = (node: { policy: NodePolicy }) =>
    node?.policy?.canReadNodeInfo || false

  const canRename = (node: { policy: NodePolicy }) =>
    node?.policy?.canRename || false

  const canRevert = (node: { policy: NodePolicy }) =>
    node?.policy?.canRevert || false

  const canRevision = (node: { policy: NodePolicy }) =>
    node?.policy?.canRevision || false

  const canSign = (node: { policy: NodePolicy }) =>
    node?.policy?.canSign || false

  const canTag = (node: { policy: NodePolicy }) => node?.policy?.canTag || false
  const canWatch = (node: { policy: NodePolicy }) =>
    node?.policy?.canWatch || false
  const canMove = (node: { policy: NodePolicy }) =>
    node?.policy?.canMoveOutOfBox || node?.policy?.canMoveWithinBox || false

  return {
    canAddChildren,
    canAdminAccess,
    canAnalyze,
    canComment,
    canDelete,
    canDirectDownload,
    canDownload,
    canI18n,
    canListChildren,
    canMoveOutOfBox,
    canMoveWithinBox,
    canPurge,
    canReadNodeInfo,
    canRename,
    canRevert,
    canRevision,
    canSign,
    canTag,
    canWatch,
    canMove,
  }
}
